module.exports = __webpack_public_path__ + "static/media/sardes_aparecida_batista.8c97880d.jpeg";